<template>
  <div class="productInfo">
    <div class="product">
      <span class="text">可选产品</span>
      <el-checkbox
        v-model="checkAllHighway"
        @change="handleCheckAllHighWayChange"
        :disabled="disabledFlag"
        >公路运输</el-checkbox
      >
      <el-checkbox
        v-model="checkAllRailway"
        @change="handleCheckAllHighRailwayChange"
        :disabled="disabledFlag"
        >铁路运输</el-checkbox
      >
    </div>
    <div class="service">
      <span class="text">可选服务</span>
      <el-checkbox-group
        v-model="checkedHighwayList"
        @change="handleHighwayList"
        :disabled="disabledFlag"
      >
        <el-checkbox v-for="high in highwayList" :label="high.value" :key="high.value">{{
          high.label
        }}</el-checkbox>
      </el-checkbox-group>
      <el-checkbox-group
        v-model="checkedRailwayList"
        @change="handleRailwayList"
        style="margin-left: 24px"
        :disabled="disabledFlag"
      >
        <el-checkbox v-for="rail in railwayList" :label="rail.value" :key="rail.value">{{
          rail.label
        }}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  export default {
    mixins: [orderMixin],
    name: 'productInfo',
    props: ['highwayTypeList', 'railwayTypeList', 'turnType', 'currStatus'],
    data() {
      return {
        checkAllHighway: false,
        checkAllRailway: false,
        serviceList: [],
        checkedHighwayList: [],
        checkedRailwayList: [],
      };
    },
    computed: {
      // 公路服务
      highwayList() {
        return this.serviceList.slice(0, 6);
      },
      railwayList() {
        return this.serviceList.slice(6, 8);
      },
      disabledFlag() {
        return this.turnType === '3' || (this.turnType === '1' && this.currStatus !== 'draft');
      },
    },
    created() {
      // 获取产品列表
      // this.getProductList();
      this.getServiceList();
      if (this.turnType === '3' || this.turnType === '1' || this.turnType === '2') {
        this.productDetail();
      }
    },
    watch: {
      highwayTypeList(newVal) {
        this.highwayTypeList = newVal;
        if (
          this.turnType === '3' ||
          this.turnType === '1' ||
          this.turnType === '2' ||
          this.turnType === '0'
        ) {
          this.productDetail();
        }
      },
      railwayTypeList(newVal) {
        this.railwayTypeList = newVal;
        if (
          this.turnType === '3' ||
          this.turnType === '1' ||
          this.turnType === '2' ||
          this.turnType === '0'
        ) {
          this.productDetail();
        }
      },
    },
    methods: {
      handleCheckAllHighWayChange(val) {
        if (val) {
          // let checkedList = [];
          // this.highwayList.forEach((high) => {
          //   checkedList.push(high.value);
          // });
          // this.checkedHighwayList = checkedList;
        } else {
          this.checkedHighwayList = [];
        }
        this.$emit('handleCheckedHighway', this.checkedHighwayList);
      },
      handleCheckAllHighRailwayChange(val) {
        if (val) {
          // let checkedList = [];
          // this.railwayList.forEach((rail) => {
          //   checkedList.push(rail.value);
          // });
          // this.checkedRailwayList = checkedList;
        } else {
          this.checkedRailwayList = [];
        }
        this.$emit('handleCheckedRailway', this.checkedRailwayList);
      },
      handleHighwayList(highwayValue) {
        // let checkedCount = highwayValue.length;
        // this.checkAllHighway = checkedCount === this.highwayList.length;
        if (highwayValue.length > 0) {
          // this.checkAllHighway = true;
        } else {
          this.checkAllHighway = false;
        }
        this.$emit('handleCheckedHighway', highwayValue);
      },
      handleRailwayList(railwayValue) {
        // let checkedCount = railwayValue.length;
        // this.checkAllRailway = checkedCount === this.railwayList.length;
        if (railwayValue.length > 0) {
          this.checkAllRailway = true;
        } else {
          this.checkAllRailway = false;
        }
        this.$emit('handleCheckedRailway', railwayValue);
      },
      productDetail() {
        console.log(this.highwayTypeList, '1111');
        console.log(this.railwayTypeList, '222');
        this.checkAllHighway = this.highwayTypeList.length > 0 ? true : false;
        this.checkAllRailway = this.railwayTypeList.length > 0 ? true : false;
        this.checkedHighwayList = this.highwayTypeList;
        this.checkedRailwayList = this.railwayTypeList;
        console.log(
          this.checkedHighwayList,
          this.checkedRailwayList,
          this.checkAllHighway,
          this.checkAllRailway,
          '222222'
        );
        // this.checkAllHighway = this.highwayTypeList.length === this.highwayList.length;
        // this.checkAllRailway = this.railwayTypeList.length === this.railwayList.length;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .productInfo {
    display: flex;
    flex-direction: column;
    .product {
      display: flex;
      flex-direction: row;
    }
    .service {
      margin-top: 16px;
      display: flex;
      flex-direction: row;
    }
  }
  .text {
    margin-right: 20px;
    margin-left: 10px;
    font-size: 14px;
  }
</style>
